import React, { useMemo } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { IoArrowBackCircle } from "react-icons/io5";
import { SubTitle } from "../../Components/CustomComponents/index.js";
import { useVehicleDetails } from "./Hooks/useVehicleDetails.js";
import styles from "./styles/user_management.module.scss";
import DetailRow from "../../Components/CustomComponents/DetailRow.js";
import { Col, Row } from "react-bootstrap";
import ZoomImage from "../../Components/ZoomImage.js";
import ClipLoader from "react-spinners/ClipLoader.js";
import VehicleReview from "./Component/VehicleReview.js";

const VehicleDetailsScreen = () => {
  const { navigate, vehicleData, isReviewFetching, reviewData } =
    useVehicleDetails();
  const detailItems = useMemo(
    () => [
      { title: "Name", value: vehicleData?.name },
      { title: "Model", value: vehicleData?.model },
      { title: "Color", value: vehicleData?.color },
      { title: "Car Type", value: vehicleData?.car_type },
      { title: "Engine Capacity", value: vehicleData?.engine_capacity },
      { title: "Rental Type", value: vehicleData?.rental_type },
      { title: "Rental Price", value: `$ ${vehicleData?.rental_price}` },
      { title: "Average Ratings", value: vehicleData?.average_ratings },
    ],
    [vehicleData]
  );
  return (
    <div className={styles.MainContainer}>
      <div className={styles.headerContainer}>
        <div className="d-flex justify-content-center align-items-center gap-2">
          <span onClick={() => navigate(-1)} role="button">
            <IoArrowBackCircle size={"26px"} />
          </span>
          <SubTitle text={"Vehicle Details"} classes="text-black" />
        </div>
      </div>

      <div className="">
        <DetailRow title={"Description"} />
        <p className="text-black ">{vehicleData?.description}</p>
        <hr className="w-100"></hr>
        <Row className="text-black g-5">
          <Col sm={12} md={6}>
            <h6 className="gray-text mb-4">Additional Detail:</h6>
            {detailItems.map(
              (item, index) =>
                item && (
                  <DetailRow
                    key={index}
                    title={item.title}
                    value={item.value}
                  />
                )
            )}
          </Col>
          <Col sm={12} md={6}>
            <h6 className="gray-text mb-4">Gallery:</h6>
            <div className="d-flex flex-wrap gap-2">
              {vehicleData?.attachments.length > 0 ? (
                vehicleData?.attachments?.map((attach, index) => (
                  <ZoomImage key={index} imageUrl={attach.media_url} />
                ))
              ) : (
                <p className="text-center text-black">No Images available.</p>
              )}
            </div>
          </Col>
        </Row>
        <hr className="w-100"></hr>
        <DetailRow title={"Reviews"} />
        {isReviewFetching ? (
          <span className="d-flex w-100 justify-content-center">
            <ClipLoader color="#000000" />
          </span>
        ) : reviewData?.data?.length > 0 ? (
          reviewData.data.map((review) => {
            return <VehicleReview data={review} key={review.id} />;
          })
        ) : (
          <p className="text-center text-black">No reviews available.</p>
        )}
      </div>
    </div>
  );
};

export default VehicleDetailsScreen;
